// import * as vp from 'vopay';
import { Api, EmailRequest, TicketsResponse } from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: Api;
};

type ReturnTuple = [TicketsResponse, (requestParams?: EmailRequest) => void, () => void];

const defaults: TicketsResponse = {
  Success: false,
  ErrorMessage: '',
  Tickets: [],
};

function useFetchTickets({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<EmailRequest>({
    Email: '',
  });

  const [response, setResponse] = useState<TicketsResponse>(defaults);
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    const sendRequest = async (requestParams: EmailRequest) => {
      setDataFetchingInfo(true, 'Loading Data', 'fullScreen');

      const res = await api.fetchTickets(requestParams, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams?: EmailRequest) => {
      setParams(requestParams || { Email: '' });
      setSendRequest(true);
    },
    () => {
      setResponse(defaults);
      setSendRequest(false);
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(useFetchTickets);
